import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { PenggunaOpdDtReqModel, PenggunaOpdDtResModel } from '../../../_model/pengguna-info.model';
import { PenggunaInfoService } from '../../../_services/pengguna-info.service';

@Component({
  selector: 'app-opd-list',
  templateUrl: './opd-list.component.html',
  styleUrls: ['./opd-list.component.scss']
})
export class OpdListComponent implements OnInit, AfterViewInit {

  redirectUrl: any[] = ['/'];

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();

  formSearch: FormGroup;

  constructor(
    private _formBuilder: FormBuilder,
    private _service: PenggunaInfoService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {
    this._activatedRoute.queryParams.subscribe(params => {
      const paramRedirectUrl: string = params['redirectUrl'];
      console.log(paramRedirectUrl);
      if ( paramRedirectUrl != undefined) {
        let splitUrl: any[] = paramRedirectUrl.split('<slash>');
        this.redirectUrl = this.redirectUrl.concat(splitUrl);
      } else {
        this.redirectUrl.push('landingpage');
      }
    });
  }

  ngOnInit() {
    this.initDataTables();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  refresh(): void {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next();
      });
  }

  initDataTables() {
    this.formSearch = this._formBuilder.group({
      kodeNama: this._formBuilder.control(null)
    });
    this.dtOptions = {
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, 'All']],
      pagingType: 'full_numbers',
      serverSide: true,
      searching: false,
      processing: true,
      autoWidth: false,
      dom: 't<\'row\'<\'col-sm-12\'ip><\'col-sm-12\'l>>',
      order: [1, 'desc'],
      ajax: (dataTablesParameters: any, callback) => {
        const search: PenggunaOpdDtReqModel = this.formSearch.value;
        this._service.datatablesOpd(dataTablesParameters, search).subscribe(resp => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
        }, error => {
          callback({
            recordsTotal: 0,
            recordsFiltered: 0,
            data: []
          });
        });
      },
      columns: [
        {
          width: '50px',
          title: 'No',
          data: null,
          orderable: false,
          className: 'text-center align-middle',
          render: (data: any, type: any, row: any, meta) => {
            return `<div class="row justify-content-center">
                        ${meta.row + 1}
                    </div>`;
          }
        },
        {width: '80px', data: 'kode', title: 'Kode', className: 'align-middle nopadding'},
        {width: '80px', data: 'nama', title: 'Nama', className: 'align-middle nopadding'},
        {
          width: '70px',
          title: 'Aksi',
          data: null,
          className: 'text-center align-middle',
          render: (data: any, type: any, row: any, meta) => {
            return `<div class="row justify-content-center">
                      <div class="btn-group btn-group-pill" role="group" aria-label="Tombol Aksi">
                        <button id="edit" title="Sunting Data" class="btn btn-outline-dark txt-dark" type="button" style="font-size: 15px">
                          <i class="fa fa-list"></i>
                        </button>
                      </div>
                    </div>`;
          }
        }
      ],
      rowCallback: (row: Node, data: PenggunaOpdDtResModel, index: number) => {
        $('#edit', row).click(() => {
          console.log(this.redirectUrl.concat(data.id));
          this._router.navigate(this.redirectUrl.concat(data.id));
        });

        return row;
      }
    };
  }

}
